var $config = Symbol.for('FluidValue:config');
export { hasFluidValue, getFluidValue, getFluidConfig, setFluidConfig, addFluidObserver };
/** Does the given value have a `FluidConfig` object? */

var hasFluidValue = function hasFluidValue(arg) {
  return !!getFluidConfig(arg);
};

function getFluidValue(arg) {
  var config = getFluidConfig(arg);
  return config ? config.get() : arg;
}

function getFluidConfig(arg) {
  if (arg) return arg[$config];
}
/** Set the methods for observing the given object. */


function setFluidConfig(target, config) {
  Object.defineProperty(target, $config, {
    value: config,
    configurable: true
  });
}

function addFluidObserver(target, observer) {
  var config = getFluidConfig(target);

  if (config) {
    config.addChild(observer);
    return function () {
      return config.removeChild(observer);
    };
  }
}
/**
 * This class stores a single dynamic value, which can be observed by multiple `FluidObserver` objects.
 *
 * In order to support non-writable streams, this class doesn't expect a `set` method to exist.
 *
 * It can send *any* event to observers, not only change events.
 */


var FluidValue =
/** @class */
function () {
  function FluidValue() {
    setFluidConfig(this, this);
  }

  return FluidValue;
}();

export { FluidValue };